import { render, staticRenderFns } from "./Table-Comparator.vue?vue&type=template&id=26121fe5&scoped=true&"
import script from "./Table-Comparator.vue?vue&type=script&lang=js&"
export * from "./Table-Comparator.vue?vue&type=script&lang=js&"
import style0 from "./Table-Comparator.vue?vue&type=style&index=0&id=26121fe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26121fe5",
  null
  
)

component.options.__file = "Table-Comparator.vue"
export default component.exports